var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "rb-radio-accordion" },
    [
      _c("input", {
        ref: "radio",
        attrs: { type: "radio", name: "accordion-radio", hidden: "" },
      }),
      _vm._v(" "),
      _c(
        "rb-label",
        {
          staticClass: "accordion-header",
          attrs: { tabindex: "0", "is-dark": _vm.isDark },
          on: {
            click: function ($event) {
              return _vm.toggleAccordion()
            },
            keypress: function ($event) {
              return _vm.toggleAccordion()
            },
          },
          scopedSlots: _vm._u(
            [
              {
                key: "right-icon",
                fn: function () {
                  return [_vm._t("icon")]
                },
                proxy: true,
              },
            ],
            null,
            true
          ),
        },
        [_vm._t("title")],
        2
      ),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }